module.exports = __webpack_public_path__ + "img/smallest-planet.b3f40b7a.svg";